import { render, staticRenderFns } from "./PreviewAnswer.vue?vue&type=template&id=78a8797e&"
import script from "./PreviewAnswer.vue?vue&type=script&lang=js&"
export * from "./PreviewAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports